import { UPDATE_LEAD, UPDATE_LEAD_ERR } from 'context/actionTypes/qcType';
import { updateLeadApi } from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const updateLead = (payload) => async (dispatch) => {
    try {
        //console.log(payload)
        let results = await axios.patch(`${updateLeadApi}`, payload, await accessToken())
        //console.log(results)
        let data = results && results.data
        //console.log('UPDATE STEP 1 JOB', data)
        dispatch({
            type: UPDATE_LEAD,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: UPDATE_LEAD_ERR,
            payload: error.response,
        });
    }
};